import core from "@/helpers/client";
const applicationService = {
  async headApplicationAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications?no-cache=1`,
      params
    );
    return result;
  },
  async getApplicationsAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications?no-cache=1`,
      params
    );
    return result;
  },
  async getApplicationAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${id}?no-cache=1`
    );
    return result;
  },
  async createApplicationAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications`,
      model
    );
    return result;
  },
  async updateApplicationAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${id}`,
      model
    );
    return result;
  },
  
  async deleteApplicationMasterByIdAsync(id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${id}`
    );
    return result;
  },
};
export default applicationService;
